import { render, staticRenderFns } from "./LayerShedDetail.vue?vue&type=template&id=08f81a3c&"
import script from "./LayerShedDetail.vue?vue&type=script&lang=js&"
export * from "./LayerShedDetail.vue?vue&type=script&lang=js&"
import style0 from "./LayerShedDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports